/**
 * Canonical `data-analytics-click-behaviour` DOM attribute values (analytics / instrumentation).
 */
export enum AnalyticsClickBehaviour {
  DownloadApp = 'download-app',
  Download = 'download',
  DownloadModal = 'download-modal',
  ModalClose = 'modal-close',
  Pagination = 'pagination',
  ExternalLink = 'external-link',
  HeaderLogo = 'header-logo',
  InternalLink = 'internal-link',
  LanguagePicker = 'language-picker',
  SSU = 'ssu',
  MobileNav = 'mobile-nav',
}

/** HTML attribute name used for behaviour tagging (e.g. Amplitude element hierarchy). */
export const ANALYTICS_CLICK_BEHAVIOUR_ATTRIBUTE = 'data-analytics-click-behaviour' as const;
